import { htmlSafe } from '@ember/template';
import { tKey } from 'ember-intl';
import {
  COLOR_CHART_STRATEGY_COMPETITOR,
  COLOR_CHART_STRATEGY_OWN_HOTEL,
  getCssVariableValue,
} from 'frontend-utils/utils/css-variable';
import getChartColor from 'frontend-utils/utils/hotel-chart-color';

// Used to prepare data for certain RS tooltips (LOS chart detail, DOW chart detail, Roomtype chart summary)
export default function prepareTooltipData(
  hotelAndMarketService,
  intl,
  hoveredSubtypeData,
  showCompetitorColors = true,
) {
  return hoveredSubtypeData.filteredPatterns
    .map((pattern) => {
      let tooltipIndicatorColor = '';
      const isOwnHotel =
        hotelAndMarketService.hotel.hotelinfo.id === pattern.hotelinfo.id;

      if (isOwnHotel) {
        tooltipIndicatorColor = showCompetitorColors
          ? getChartColor(
              hotelAndMarketService.hotel.hotelinfo.id,
              hotelAndMarketService.primaryAndSecondaryCompetitors,
            )
          : getCssVariableValue(COLOR_CHART_STRATEGY_OWN_HOTEL);
      } else {
        tooltipIndicatorColor = showCompetitorColors
          ? getChartColor(
              pattern.hotelinfo.id,
              hotelAndMarketService.primaryAndSecondaryCompetitors,
            )
          : getCssVariableValue(COLOR_CHART_STRATEGY_COMPETITOR);
      }

      const patternData = {
        name: pattern.hotelinfo.name,
        rate: pattern.rate,
        formattedRate: pattern.formattedRate,
        backgroundColor: htmlSafe(`background-color: ${tooltipIndicatorColor}`),
        isOwnHotel,
      };

      if (pattern.rsbaserate) {
        patternData.roomname = pattern.rsbaserate.roomname;
        patternData.rateTypeIcons = pattern.rsbaserate.rateTypeIcons;
      } else {
        patternData.roomname = intl.t(tKey('general.missing'));
        patternData.rateTypeIcons = [];
      }

      return patternData;
    })
    .sort((a, b) => {
      // Perform the same sort as in sortedPositionArray of the rssubtype model
      if (a.rate > b.rate) {
        return -1;
      }
      if (b.rate > a.rate) {
        return 1;
      }
      // Subsort on hotel name (ascending) in case of equal rates
      return a.name.localeCompare(b.name);
    });
}
